import { markdownToHtml } from '@esa/shared';
import { cn } from '../ui/index.js';

/**
 * A reply or note as written in the composer (Markdown), rendered.
 *
 * The HTML comes from `markdownToHtml`, which escapes everything and emits
 * only its own small set of tags, so it is safe to set. Use this only for
 * what the desk wrote: a requester's inbound message is shown as text.
 */
export function MarkdownBody({ text, className }: { text: string; className?: string }) {
  return (
    <div
      className={cn('rich-text text-sm leading-relaxed text-ink', className)}
      // eslint-disable-next-line react/no-danger -- escaped by markdownToHtml
      dangerouslySetInnerHTML={{ __html: markdownToHtml(text) }}
    />
  );
}
